module.exports = __webpack_public_path__ + "img/457d467.png";